export default __webpack_public_path__ + "assets/0a0dc0b78cbb1c1d588412a5ed13322a.woff2";